import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { ExternalTradeGuard } from 'src/pages/reporting/secondary-trading/external-trades/common/guards';
import { useExternalTrade } from 'src/pages/reporting/secondary-trading/external-trades/details/use-external-trade';

const Page = lazy(() => import('./page'));

const ExternalTradeLoader: FC = () => {
  const { externalTradeId } = useParams<{
    externalTradeId: string;
  }>();

  const externalTradeRequest = useExternalTrade(externalTradeId);

  if (!externalTradeRequest.response) return <PageSpinner />;

  return <Page externalTrade={externalTradeRequest.response.data} />;
};

export const ExternalTradeEdit: FC = () => (
  <ExternalTradeGuard>
    <ExternalTradeLoader />
  </ExternalTradeGuard>
);
